import { GoldCheckBox } from "../atoms/goldCheckBox";

export const CheckboxListBoxGold = (props) => {
    const { divStyle, data, checkAreaStyle, onChange, id, name, className } = props;
    return (
        <div style={divStyle}>
            {data ? data.map((d, index) => (
                <GoldCheckBox
                    checkAreaStyle={checkAreaStyle}
                    key={id + index}
                    id={id}
                    name={name}
                    className={className}
                    onChange={onChange}
                    item={d.value}
                    value={d.value}
                    checked={d.checked}
                    disabled={d.disabled} />
            )) : null}
        </div>
    );
};